<template>
    <div class="breadcrumbs flex items-center justify-left py-1">
        <inertia-link href="/">Dashboard</inertia-link>
        <i class="fad fa-chevron-right"></i>
        <slot />
    </div>
</template>

<script>
export default {
    props: {}
};
</script>